import { useContext, useEffect, useRef, useState } from "react";
import SignupButton from "../Components/SignupButton/SignupButton";
import "../../src/App.css";
import styles from "./styles/SignupPage.module.css";
import { useLocation, useNavigate } from "react-router";
import { useUserAuth } from "../context/UserAuthContext";
import logo from "../assests/goViralWhiteLogo.svg";
import Context from "../context/Context";
import * as _ from "lodash";
import Header from "../Components/Header/Header";
import EnterOtp from "../Components/EnterOtp/EnterOtp";
import googleLogo from "../assests/googleLogoBlack.svg";
import fbLogo from "../assests/facebook.svg";
import LoadingFromCenter from "../Components/LoadingFromCenter/LoadingFromCenter";
import SignupPageHeader from "../Components/Header/SignupPageHeader";
import RetryLoginPopup from "../Components/RetryLoginPopup/RetryLoginPopup";
import axios from "axios";
import downArrow from "../assests/downArrowBlack.svg";
import upArrow from "../assests/upArrowBlack.svg";
import ForgotPasswordPopup from "../Components/ForgotPasswordPopup/ForgotPasswordPopup";
import InstaGramParticipatePopup from "../Components/InstaGramParticipatePopup/InstaGramParticipatePopup";
import LoadingCircle from "./InstallPage/LoadingCircle/LoadingCircle";
import PopupWrapper from "../Layout/PopupWrapper";
import ContestTerms from "../Components/ContestDescripion/ContestTerms";

function SignupPage() {
  const {
    details,
    userIdToken,
    isMobile,
    loadHomePageDetails,
    organizerName,
    customLogin,
    isDomainAllowed,
  } = useContext(Context);
  const {
    sendOtp,
    otpShow,
    numberVerificationLoading,
    enterUserDisplayName,
    patchDisplayNameAndCreateUser,
    namePatchLoading,
    googleSignIn,
    setEnterUserDisplayName,
    pageLoading,
    setOtpShow,
    otpError,
    retryCreateUser,
    currentUser,
    emailError,
    emailSignIn,
    setEmailError,
    emailLogin,
    faceBookSignIn,
    anonymousLogin,
  } = useUserAuth();
  const [invalidPhone, setInvalidPhone] = useState("");
  const [showEmailLogin, setShowEmailLogin] = useState(true);
  const [instaGramParticipate, setInstagramParticipate] = useState(false);
  const [forgotPasswordPopup, setForgotPasswordPopup] = useState(false);
  const location = useLocation();
  const [mobileTerms, setMobileTerms] = useState("");
  const [landing, setLanding] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState();
  const [showTerms, setShowTerms] = useState(false);
  const [numberObj, setNumberObj] = useState({
    countryCode: "",
    number: null,
  });
  const [emailObj, setEmailObj] = useState({});
  const [userDetails, setUserDetails] = useState({
    name: "",
    whatsApp: true,
  });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [filterdCountryCodes, setFilteredCountryCode] = useState([]);
  const dropdownRef = useRef(null);
  const [countryCodes, setCountryCodes] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({});
  const toggleOpen = () => {
    setIsDropdownOpen((prev) => !prev);
  };
  const isInstagram =
    navigator.userAgent.includes("Instagram") ||
    navigator.userAgent.match(/FBAN|FBAV/i);
  const imageSrc = isDropdownOpen ? upArrow : downArrow;
  const token = userIdToken || currentUser?.accessToken;
  const campaignId = window.location.pathname
    .split("/")[2]
    ?.replace(/\.html$/, "");
  useEffect(() => {
    if (campaignId && _.isEmpty(details)) {
      loadHomePageDetails(organizerName, campaignId);
    }
    // eslint-disable-next-line
  }, [organizerName]);
  useEffect(() => {
    getCountryCodes();
  }, []);

  useEffect(() => {
    if (isMobile) {
      loadTermsMobile();
    }
  }, [isMobile]);

  const loadTermsMobile = async () => {
    try {
      const data = await axios.get(
        `https://storage.googleapis.com/goviralcampaign/phone_tandc.json`,
      );
      setMobileTerms(data?.data);
    } catch (error) {
      console.log(error.message);
      //navigate("/error")
    }
  };
  useEffect(() => {
    setOtpShow(false);
    setEnterUserDisplayName({ ...enterUserDisplayName, display: false });
    window.recaptchaVerifier = null;
  }, []);
  const validatePhone = (code) => {
    let regexPhone =
      // eslint-disable-next-line no-useless-escape
      /^\+(?:[0-9]●?){6,14}[0-9]$/;

    if (code.match(regexPhone)) {
      setInvalidPhone("");
      return true;
    } else {
      setInvalidPhone("Invalid Phone number");
      return false;
    }
  };

  const handleSubmitNumber = (e) => {
    e.preventDefault();

    if (_.isEmpty(numberObj.countryCode)) {
      setInvalidPhone("Select Country Code");
      return;
    }
    if (_.isEmpty(numberObj.number)) {
      setInvalidPhone("Invalid Phone number");
      return;
    }
    let temp = numberObj.countryCode + numberObj.number;
    temp = temp.replace(/\s+/g, "");
    const validateRespose = validatePhone(temp);
    if (!validateRespose) {
      return;
    }
    setPhoneNumber(`${temp}`);
    sendOtp(`${temp}`);
  };

  const handleCooperateGuestLogin = async (e) => {
    e.preventDefault();
    setEmailError("");
    if (!emailObj.name) {
      setEmailError("Please Enter your Name");
      return;
    }
    if (!emailObj.uniqueId) {
      setEmailError("Please Enter your Fusion ID");
      return;
    }
    if (!emailObj.pin) {
      setEmailError("Please Enter the contest pin");
      return;
    } else {
      if (emailObj.pin != details?.campaignPin) {
        setEmailError("Please Enter the correct pin");
        return;
      }
    }
    localStorage.setItem("uniqueId", emailObj.uniqueId);
    anonymousLogin(emailObj?.name, emailObj?.uniqueId);
  };

  const handleSubmitEmailPassword = async (e, type) => {
    e.preventDefault();
    setEmailError("");
    if (!userDetails?.terms && isMobile) {
      setEmailError("Please Accept terms and condition");
      return;
    }
    if (_.isEmpty(emailObj.name) && type == "signin") {
      setEmailError("Please Enter your Name");
      return;
    }
    if (_.isEmpty(emailObj.email)) {
      setEmailError("Please Enter Email address");
      return;
    }
    if (_.isEmpty(emailObj.password)) {
      setEmailError("Please Enter a password");
      return;
    }
    if (!_.isEmpty(details?.allowedDomains)) {
      const domainAllowed = await isDomainAllowed(
        emailObj?.email,
        details?.allowedDomains,
      );
      if (!domainAllowed) {
        setEmailError(
          `This email address is not authorized to access the contest. Kindly get in touch with your Company Admin for access.`,
        );
        return;
      }
    }
    switch (type) {
      case "signin":
        emailSignIn(emailObj?.name, emailObj?.email, emailObj?.password);
        break;
      default:
        emailLogin(emailObj?.email, emailObj?.password);
        break;
    }
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    setNumberObj((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };
  const handleInputChangeEmail = (e) => {
    e.preventDefault();
    setEmailObj((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };
  const handleWhatappStausChange = (e) => {
    let status = !userDetails?.whatsApp;
    setUserDetails((prevState) => ({
      ...prevState,
      whatsApp: status,
    }));
  };
  const handleNameChange = (e) => {
    setUserDetails((prevState) => ({
      ...prevState,
      name: e.target.value,
    }));
  };
  const handleSubmit = () => {
    let otpResponse = { _tokenResponse: { idToken: token } };
    patchDisplayNameAndCreateUser(
      enterUserDisplayName?.otpResponse || otpResponse,
      userDetails,
    );
  };

  const getCountryCodes = async () => {
    try {
      const data = await axios.get(
        `https://storage.googleapis.com/goviralcampaign/CountryCodes.json`,
      );
      setCountryCodes(data.data);
      setFilteredCountryCode(data.data);
    } catch (error) {
      console.log(error.message);
      //navigate("/error")
    }
  };
  useEffect(() => {
    handleCountryCodeChange({
      name: "India",
      code: "+91",
      shortCode: "IN",
    });
  }, []);
  const handleCountryCodeChange = (country) => {
    let { code } = country;
    setSelectedCountry(country);
    setNumberObj((prevState) => ({
      ...prevState,
      countryCode: code,
    }));
    setIsDropdownOpen(false);
  };
  const handleCountryChange = (event) => {
    const inputValue = event.target.value;

    // Filter country codes based on user input
    const filteredCountryCodes = countryCodes?.filter((country) =>
      country.code.includes(inputValue),
    );

    setFilteredCountryCode(filteredCountryCodes);
    setNumberObj((prevState) => ({
      ...prevState,
      countryCode: event.target.value,
    }));
    // Update the dropdown visibility
    setIsDropdownOpen(filteredCountryCodes.length > 0);

    // When the input is cleared, close the dropdown
    if (!inputValue) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the modal is open and the clicked target is not within the modal,
      //then close the modal
      if (
        isDropdownOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isDropdownOpen]);

  const getCountryFlag = (code) => {
    let lowerCaseCode = code?.toLowerCase();
    return (
      <img
        src={`https://storage.googleapis.com/goviralcampaign/countryFlags/${lowerCaseCode}.png`}
        className="h-full w-full "
      />
    );
  };
  const handleGoogleSignin = () => {
    if (
      navigator.userAgent.includes("Instagram") ||
      navigator.userAgent.match(/FBAN|FBAV/i)
    ) {
      setInstagramParticipate(true);
      return;
    }
    googleSignIn();
  };

  return (
    <>
      {pageLoading && (
        <PopupWrapper>
          <div className={styles.popupWrapper}>
            <div className="w-[40px] h-[40px]">
              <LoadingCircle />
            </div>
          </div>
        </PopupWrapper>
      )}
      {showTerms && (
        <ContestTerms
          terms={mobileTerms}
          setShowDetails={setShowTerms}
          heading={"Terms and Conditions"}
        />
      )}
      {instaGramParticipate && (
        <InstaGramParticipatePopup setPopup={setInstagramParticipate} />
      )}
      {forgotPasswordPopup && (
        <ForgotPasswordPopup setPopup={setForgotPasswordPopup} />
      )}
      <div className="widthController">
        <div className={styles.signupPage}>
          <SignupPageHeader
            themeImage={details?.themeImage}
            landing={landing}
            setLanding={setLanding}
          />

          <div className="w-[100%]">
            <div className="theBlurBgSignup  mt-[75px] rounded-t-[24px]  w-[100%] min-h-[calc(100vh_-_75px)] pb-[50px]">
              {landing ? (
                <>
                  <div className={styles.buttonContainer}>
                    {pageLoading && <LoadingFromCenter />}
                    <h3 className="text-privacy  mb-[14px] text-[#F6F5F5]">
                      Welcome!
                    </h3>
                    {customLogin && (
                      <img
                        src={customLogin}
                        className="w-fit rounded-[10px] h-[100px] object-contain"
                      />
                    )}
                  </div>

                  {details?.hideSignin ? (
                    <div className="px-[20px]">
                      <div className="flex items-center relative">
                        <div class={styles.mobileLogin}>
                          <input
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Name"
                            className="text-regular-callout mb-[16px]"
                            onChange={handleInputChangeEmail}
                            value={emailObj?.name}
                          />
                          <input
                            type="text"
                            id="uniqueId"
                            name="uniqueId"
                            placeholder="Fusion ID"
                            className="text-regular-callout mb-[16px]"
                            onChange={handleInputChangeEmail}
                            value={emailObj?.uniqueId}
                          />
                          <input
                            type="text"
                            id="pin"
                            name="pin"
                            placeholder="PIN"
                            className="text-regular-callout mb-[16px]"
                            onChange={handleInputChangeEmail}
                            value={emailObj?.pin}
                          />
                        </div>
                      </div>
                      {emailError && (
                        <div className="text-small text-left w-[100%] my-[10px]">
                          <span className="text-red-600">*</span>
                          {emailError}
                        </div>
                      )}
                      <button
                        className={`${styles.button} text-regular-medium bg-[#EB0256] mb-[16px]`}
                        onClick={(e) => {
                          handleCooperateGuestLogin(e);
                        }}
                        disabled={numberVerificationLoading || pageLoading}
                      >
                        Continue
                      </button>
                    </div>
                  ) : (
                    <div className="px-[20px] ">
                      {!details?.hideGuestSignin && !isMobile && (
                        <>
                          <button
                            className={`${styles.button} text-regular-medium bg-none border-[1px] border-[#fff]`}
                            onClick={() => anonymousLogin("", "")}
                          >
                            Continue as a guest
                          </button>
                          <div className="flex items-center gap-[18px]  my-[35px]">
                            <div className="seperator" />
                            <p>OR</p>
                            <div className="seperator " />
                          </div>
                        </>
                      )}

                      <div>
                        <h4>New User?</h4>
                        <p className="text-regular-medium mt-[12px] mb-[16px] opacity-80 w-[90%] mx-auto">
                          Sign up to get started today.
                        </p>
                        <button
                          style={{ color: "#000" }}
                          className={`${styles.button} text-regular-medium bg-[#fff]`}
                          onClick={() => {
                            setLanding(false);
                            setShowEmailLogin(false);
                          }}
                        >
                          Sign up with Email
                        </button>
                      </div>
                      <div className="flex items-center gap-[18px]  my-[35px]">
                        <div className="seperator" />
                        <p>OR</p>
                        <div className="seperator " />
                      </div>
                      <div>
                        <h4>Registered Users?</h4>
                        <p className="text-regular-medium mt-[12px] mb-[16px] opacity-80 w-[90%] mx-auto">
                          Have an account? Sign in now.
                        </p>
                        <button
                          className={`${styles.button} text-regular-medium bg-[#EB0256]`}
                          onClick={() => {
                            setLanding(false);
                            setShowEmailLogin(true);
                          }}
                        >
                          Sign in with Email
                        </button>
                        {!isMobile && !details?.hideGoogle && !isInstagram && (
                          <button
                            style={{ color: "#000" }}
                            className={`${styles.button} text-regular-medium bg-[#FFF] flex items-center justify-center gap-[14px] mt-[20px]`}
                            onClick={handleGoogleSignin}
                            disabled={pageLoading}
                          >
                            <img src={googleLogo} alt="" />
                            Sign in with Google
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className={styles.buttonContainer}>
                    {pageLoading && <LoadingFromCenter />}
                    <h3 className="text-largeInter mb-[14px] text-[#F6F5F5]">
                      {showEmailLogin
                        ? "Sign in to continue"
                        : "Sign up to continue"}
                    </h3>
                    <p className="text-small text-opacity-60 text-[#CDCDCD]">
                      To unlock all the features and enjoy a personalized
                      experience, please log in to your account. Logging in not
                      only enhances your user experience but also ensures the
                      security of your data.
                    </p>
                  </div>

                  {!showEmailLogin && (
                    <div className="px-[20px]">
                      <div className="mb-[32px]">
                        <div className="flex items-center relative">
                          <div class={styles.mobileLogin}>
                            <input
                              type="text"
                              id="name"
                              name="name"
                              placeholder="Name"
                              className="text-regular-callout mb-[16px]"
                              onChange={handleInputChangeEmail}
                              value={emailObj?.name}
                            />
                            <input
                              type="email"
                              id="email"
                              name="number"
                              placeholder="Email"
                              className="text-regular-callout mb-[16px]"
                              onChange={handleInputChangeEmail}
                              value={emailObj?.email}
                            />
                            <input
                              type="password"
                              id="password"
                              name="number"
                              placeholder="Password"
                              className="text-regular-callout"
                              onChange={handleInputChangeEmail}
                              value={emailObj?.password}
                            />
                            {isMobile && (
                              <div className="flex  items-center justify-start   gap-[10px] mt-[25px]">
                                <input
                                  type="checkbox"
                                  id="tc"
                                  name="tc"
                                  className="w-[30px] h-[30px] rounded-[5px] focus:outline-none"
                                  onClick={() =>
                                    setUserDetails((prevState) => ({
                                      ...prevState,
                                      terms: !prevState?.terms,
                                    }))
                                  }
                                />
                                <label
                                  htmlFor="tc"
                                  className="text-[#B5B5B5] font-Inter font-[400] text-[17px] leading-[24px]"
                                >
                                  I agree to the{" "}
                                </label>
                                <a
                                  onClick={() => setShowTerms(true)}
                                  className="text-[#B5B5B5] font-Inter font-[400] text-[17px] leading-[24px] underline  underline-offset-1 cursor-pointer"
                                >
                                  terms and conditions
                                </a>
                              </div>
                            )}
                          </div>
                        </div>

                        {emailError && (
                          <div className="text-small text-left w-[100%] my-[10px]">
                            <span className="text-red-600">*</span>
                            {emailError}
                          </div>
                        )}
                      </div>
                      <button
                        className={`${styles.button} text-regular-medium bg-[#EB0256] mb-[16px]`}
                        onClick={(e) => {
                          handleSubmitEmailPassword(e, "signin");
                        }}
                        disabled={numberVerificationLoading || pageLoading}
                      >
                        Sign up
                      </button>
                      <p
                        className="text-left mb-[10px] text-small text-center cursor-pointer text-[#F6F5F5]"
                        onClick={() => {
                          setEmailError("");
                          setShowEmailLogin(true);
                        }}
                      >
                        Already have an account?{" "}
                        <span className="ml-[5px]  underline text-[#0092D6]">
                          Sign in
                        </span>
                      </p>
                    </div>
                  )}
                  {showEmailLogin && (
                    <div className="px-[20px]">
                      <div className="mb-[32px]">
                        <div className="flex items-center relative">
                          <div class={styles.mobileLogin}>
                            <input
                              type="email"
                              id="email"
                              name="number"
                              placeholder="Email"
                              className="text-regular-callout mb-[16px]"
                              onChange={handleInputChangeEmail}
                              value={emailObj?.email}
                            />
                            <input
                              type="password"
                              id="password"
                              name="password"
                              placeholder="Password"
                              className="text-regular-callout"
                              onChange={handleInputChangeEmail}
                              value={emailObj?.password}
                            />
                            {isMobile && (
                              <div className="flex  items-center justify-start   gap-[10px] mt-[25px]">
                                <input
                                  type="checkbox"
                                  id="tc"
                                  name="tc"
                                  className="w-[30px] h-[30px] rounded-[5px] focus:outline-none"
                                  onClick={() =>
                                    setUserDetails((prevState) => ({
                                      ...prevState,
                                      terms: !prevState?.terms,
                                    }))
                                  }
                                />
                                <label
                                  htmlFor="tc"
                                  className="text-[#B5B5B5] font-Inter font-[400] text-[17px] leading-[24px]"
                                >
                                  I agree to the{" "}
                                </label>
                                <a
                                  onClick={() => setShowTerms(true)}
                                  className="text-[#B5B5B5] font-Inter font-[400] text-[17px] leading-[24px] underline  underline-offset-1 cursor-pointer"
                                >
                                  terms and conditions
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="flex items-center justify-beween">
                          {emailError && (
                            <div className="text-small text-left w-[100%] my-[10px]">
                              <span className="text-red-600">*</span>
                              {emailError}
                            </div>
                          )}
                          <p
                            className="text-right w-full my-[10px] text-small cursor-pointer text-[#0092D6]"
                            onClick={() => {
                              setEmailError("");
                              setForgotPasswordPopup(true);
                            }}
                          >
                            Forgot your password?
                          </p>
                        </div>
                      </div>
                      <button
                        className={`${styles.button} text-regular-medium bg-[#EB0256] mb-[16px]`}
                        onClick={(e) => handleSubmitEmailPassword(e, "login")}
                        disabled={numberVerificationLoading || pageLoading}
                      >
                        Sign in
                      </button>
                      <p
                        className="text-left mb-[10px] text-small text-center cursor-pointer text-[#F6F5F5]"
                        onClick={() => setShowEmailLogin(false)}
                      >
                        Don't have an account?
                        <span className="ml-[5px] underline text-[#0092D6]">
                          Sign up
                        </span>
                      </p>
                    </div>
                  )}
                  {!isMobile && !details?.hideGoogle && !isInstagram && (
                    <>
                      <p className="text-regular my-[28px]">OR</p>
                      <div className="px-[20px]">
                        <button
                          style={{ color: "#000" }}
                          className={`${
                            styles.button
                          } text-regular-medium bg-[#FFF] flex items-center justify-center gap-[14px]
                        ${
                          (navigator.userAgent.includes("Instagram") ||
                            navigator.userAgent.match(/FBAN|FBAV/i)) &&
                          "opacity-50"
                        }
                         `}
                          onClick={handleGoogleSignin}
                          disabled={pageLoading}
                        >
                          <img src={googleLogo} alt="" />
                          {showEmailLogin
                            ? "Sign in with Google"
                            : "Sign up with Google"}
                        </button>
                      </div>
                    </>
                  )}
                  {/* {!enterUserDisplayName?.display && (
                <div className={styles.mobileLogin}>
                  {!otpShow && (
                    <>
                      <div className="mb-[32px]">
                        <p className="text-left mb-[10px] text-small">
                          Enter Phone Number
                        </p>
                        <div className="flex items-center relative">
                          <div
                            ref={dropdownRef}
                            className={styles.country}
                            onClick={toggleOpen}
                          >
                            <img src={imageSrc} />
                            {!_.isEmpty(selectedCountry) && (
                              <div className="aspect-[4/3] h-[20px]">
                                {getCountryFlag(selectedCountry?.shortCode)}
                              </div>
                            )}
                            {isDropdownOpen && (
                              <div className={styles.dropdownList}>
                                {filterdCountryCodes?.map((country) => (
                                  <div
                                    key={country?.shortCode}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleCountryCodeChange(country);
                                    }}
                                    className="flex items-center gap-[10px]"
                                  >
                                    <div className="w-[30px] h-[20px]">
                                      {getCountryFlag(country?.shortCode)}
                                    </div>
                                    {country?.code} - {country?.name}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          <div class={styles.phoneInput}>
                            <input
                              type="text"
                              id="countryCode"
                              name="countryCode"
                              maxlength="4"
                              className="text-regular-callout"
                              onChange={handleCountryChange}
                              onClick={toggleOpen}
                              autoComplete="off"
                              value={numberObj?.countryCode}
                              readOnly
                            />
                            <input
                              type="number"
                              id="number"
                              name="number"
                              placeholder="Enter phone number"
                              className="text-regular-callout"
                              onChange={handleInputChange}
                              value={numberObj?.number}
                            />
                          </div>
                        </div>

                        {invalidPhone && (
                          <div className="text-small text-left w-[100%] mb-[12px]">
                            <span className="text-red-600">*</span>
                            {invalidPhone}
                          </div>
                        )}
                        {otpError && (
                          <div className="text-small text-left w-[100%] mb-[12px]">
                            <span className="text-red-600">*</span>
                            {otpError}
                          </div>
                        )}
                        <div className="flex items-start justify-start gap-[15px]">
                          <input
                            type="checkbox"
                            name="whatsApp"
                            onChange={handleWhatappStausChange}
                            checked={userDetails?.whatsApp}
                          />
                          <label
                            htmlFor="whatsApp"
                            className="text-small text-left"
                          >
                            I would love to receive contest updates in the above
                            WhatsApp number
                          </label>
                        </div>
                      </div>
                      <button
                        className={`${styles.button} text-regular-medium bg-[#EB0256] mb-[16px]`}
                        onClick={handleSubmitNumber}
                        disabled={numberVerificationLoading || pageLoading}
                      >
                        Continue
                      </button>
                      {numberVerificationLoading && <LoadingFromCenter />}

                      <div className="flex items-center justify-center mb-[28px]">
                        <p className="text-small text-[#787878] max-w-[90%]">
                          We will send you a code to verify your phone number
                        </p>
                      </div>
                    </>
                  )}
                  {otpShow && <EnterOtp number={phoneNumber} />}
                </div>
              )} */}
                  {/* {enterUserDisplayName?.display && (
                <div className={styles.mobileLogin}>
                  <div className="mb-[24px]">
                    <p className="text-left mb-[10px] text-small">
                      Please enter your name
                    </p>
                    <input type="text" id="name" onChange={handleNameChange} />
                  </div>
                  <button
                    className={`${styles.button} text-regular-medium bg-[#EB0256] mb-[16px]`}
                    onClick={handleSubmit}
                    disabled={namePatchLoading || pageLoading}
                  >
                    Continue
                  </button>
                  {namePatchLoading && <LoadingFromCenter />}
                </div>
              )} */}
                  {/* {!otpShow &&
                details?.emailLogin &&
                location?.state?.participate && (
                  <div className="px-[20px]">
                    <p className="text-regular mb-[28px]">OR</p>
                    <button
                      className={`${styles.button} text-regular-medium bg-[#0092D6]   flex items-center justify-center gap-[14px]`}
                      onClick={googleSignIn}
                      disabled={pageLoading}
                    >
                      <img src={googleLogo} alt="" />
                      Sign in with Google
                    </button>
                  </div>
                )} */}

                  {/* <div className="p-[20px]">
                <button
                  className={`${styles.button} text-regular-medium bg-[#0092D6]   flex items-center justify-center gap-[14px]`}
                  onClick={faceBookSignIn}
                  disabled={pageLoading}
                >
                  <img src={fbLogo} alt="" className="h-[20px]" />
                  Sign in with Facebook
                </button>
              </div> */}
                </>
              )}
            </div>
          </div>
        </div>
        <div id="recaptcha-container"></div>
      </div>

      {retryCreateUser && <RetryLoginPopup />}
    </>
  );
}

export default SignupPage;
